import { type IAddress } from '@mahawi/eshop-common/src/types';
import React from 'react';

import AddressDisplay from '../address-display';

interface IDeliveryAddressSectionProps {
  deliveryAddressIsDifferent: boolean;
  deliveryAddress: IAddress;
}

export const DeliveryAddressSection = React.memo(
  function DeliveryAddressSection({
    deliveryAddressIsDifferent,
    deliveryAddress,
  }: IDeliveryAddressSectionProps): React.ReactElement | null {
    if (!deliveryAddressIsDifferent) {
      return null;
    }

    return <AddressDisplay address={deliveryAddress} />;
  },
);
